'use strict'

/**
 * Source-lot eligibility/display contract for the upstream melt picker.
 * Eligibility is canonical; chip wording and palette are display-only.
 */

export const SOURCE_LOT_STATUSES = Object.freeze({
  MELT_COMPLETED: 'melt_completed',
  AWAITING_CUSTOMER_APPROVAL: 'awaiting_customer_approval',
  SETTLED: 'settled',
})

export const ELIGIBLE_SOURCE_LOT_STATUSES = Object.freeze([
  SOURCE_LOT_STATUSES.MELT_COMPLETED,
  SOURCE_LOT_STATUSES.AWAITING_CUSTOMER_APPROVAL,
  SOURCE_LOT_STATUSES.SETTLED,
])

const ELIGIBLE_STATUS_SET = new Set(ELIGIBLE_SOURCE_LOT_STATUSES)

const STATUS_LABELS = Object.freeze({
  [SOURCE_LOT_STATUSES.MELT_COMPLETED]: 'Melt complete',
  [SOURCE_LOT_STATUSES.AWAITING_CUSTOMER_APPROVAL]: 'Awaiting customer approval',
  [SOURCE_LOT_STATUSES.SETTLED]: 'Settled',
})

const STATUS_RISK_TIERS = Object.freeze({
  [SOURCE_LOT_STATUSES.MELT_COMPLETED]: 'high',
  [SOURCE_LOT_STATUSES.AWAITING_CUSTOMER_APPROVAL]: 'mild',
  [SOURCE_LOT_STATUSES.SETTLED]: 'low',
})

const STATUS_COLORS = Object.freeze({
  [SOURCE_LOT_STATUSES.MELT_COMPLETED]: 'orange lighten-2',
  [SOURCE_LOT_STATUSES.AWAITING_CUSTOMER_APPROVAL]: 'amber lighten-3',
  [SOURCE_LOT_STATUSES.SETTLED]: 'success',
})

export const isEligibleSourceLotStatus = (status) => ELIGIBLE_STATUS_SET.has(status)

export const sourceLotStatusLabel = (status) => STATUS_LABELS[status] || status || '--'

export const sourceLotRiskTier = (status) => STATUS_RISK_TIERS[status] || 'unknown'

export const sourceLotStatusColor = (status) => STATUS_COLORS[status] || 'grey lighten-3'

export const sourceLotStatusTextColor = (status) =>
  status === SOURCE_LOT_STATUSES.SETTLED ? 'white' : 'grey darken-3'

export const sourceLotStatusFilterOptions = (lots) => {
  const present = new Set()
  for (const lot of lots || []) {
    if (isEligibleSourceLotStatus(lot?.status)) present.add(lot.status)
  }
  return ELIGIBLE_SOURCE_LOT_STATUSES
    .filter((status) => present.has(status))
    .map((status) => ({value: status, text: sourceLotStatusLabel(status)}))
}
